import { USER_ROLES } from "./roles";

export const ACCESS_RULES = {
  HOME: [
    USER_ROLES.ADMIN,
    USER_ROLES.SALESMAN,
    USER_ROLES.LIMITED_ADMIN,
    USER_ROLES.USER_PRIVILEGED,
    USER_ROLES.PERICIA_CREATOR
  ],
  COSTUMERS_CREATE: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.PERICIA_CREATOR, USER_ROLES.USER_PRIVILEGED],
  COSTUMERS_LIST: [
    USER_ROLES.ADMIN,
    USER_ROLES.LIMITED_ADMIN,
    USER_ROLES.SALESMAN,
    USER_ROLES.PERICIA_CREATOR,
    USER_ROLES.USER_PRIVILEGED
  ],
  COSTUMERS_EDIT: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN],
  CARS: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.PERICIA_CREATOR, USER_ROLES.USER_PRIVILEGED],
  SERVICE_ORDERS: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.USER_PRIVILEGED, USER_ROLES.PERICIA_CREATOR],
  PERICIAS: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.USER_PRIVILEGED, USER_ROLES.PERICIA_CREATOR],
  INVOICES: [USER_ROLES.ADMIN, USER_ROLES.LIMITED_ADMIN, USER_ROLES.SALESMAN],
  REPORTS: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.LIMITED_ADMIN],
  METRICS: [USER_ROLES.ADMIN],
  USERS: [USER_ROLES.ADMIN],
  MECHANIC_PERICIAS: [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.USER_PRIVILEGED],
  BALANCE: [USER_ROLES.ADMIN, USER_ROLES.SALESMAN, USER_ROLES.USER, USER_ROLES.USER_PRIVILEGED]
} as const;

export const canAccess = (role: string | undefined, allowedRoles: readonly string[]) =>
  allowedRoles.includes(role || USER_ROLES.USER);
